const isProduction = process.env.NODE_ENV === 'production';
const excludeSearchEngines = process.env.GATSBY_EXCLUDE_SEARCH_ENGINES === 'true';

const supportedLanguages = ['en', 'es'];

const languages = {
    es: 'Español',
    en: 'English',
    fr: 'Français',
    gr: 'Ελληνικά',
    it: 'Italiano',
    pt: 'Português',
    zh: '中文',
    ja: '日本語',
    ko: '한국어',
    vi: 'Tiếng Việt',
    id: 'Bahasa Indonesia',
    th: 'ภาษาไทย',
    uk: 'Українська',
};

const getUserLang = (laguangeSelected) => {
    let browserLanguage = [];

    if (typeof window !== 'undefined') {
        browserLanguage = navigator.languages;
    }

    const langs = [laguangeSelected, ...browserLanguage, 'en'];
    return langs
        .filter((x) => !!x)
        .reduce((prev, next) => {
            const singleLocale = next.split('-');
            if (singleLocale.length > 1) {
                if (!prev.regions) {
                    prev.regions = [next];
                } else if (!prev.regions.includes(next)) {
                    prev.regions.push(next);
                }
            }

            if (!prev.langs) {
                prev.langs = [singleLocale[0]];
            } else if (!prev.langs.includes(singleLocale[0])) {
                prev.langs.push(singleLocale[0]);
            }

            return prev;
        }, {});
};

const getSingleLocale = (localeWithoutFormat) => {
    const singleLocale = localeWithoutFormat.split('-');
    return singleLocale[0];
};

const getLocale = (locale) => (locale === 'es' ? 'es-US' : locale);

const formatSlug = (slug = '', locale = 'en') => {
    const singleLocale = getSingleLocale(locale);
    const result = slug.replace(':', '').replace(/\/$/, '');
    return `${singleLocale === 'en' ? '' : 'es/'}trade-pro/${result}`;
};

module.exports = {
    formatSlug,
    getSingleLocale,
    getLocale,
    getUserLang,
    isProduction,
    languages,
    supportedLanguages,
    excludeSearchEngines,
};
